import { Box, Typography, Skeleton } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { ThumbType } from '~/shared/api'
import { InspectionPhotoTypeEnum } from '~/shared/config/enums'
import { Gallery, mapPhotoToImage } from '~/shared/ui/Gallery'
import { GalleryImage } from '~/shared/ui/Gallery/type'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type PhotosProps = {
  photos: ThumbType[]
  loading: boolean
}

export function Photos({ photos, loading }: PhotosProps) {
  const { t } = useTranslation()

  const carPhotos = photos
    .filter(({ type }) => type === InspectionPhotoTypeEnum.CAR)
    .map(mapPhotoToImage)
    .filter((photo): photo is GalleryImage => !!photo)

  const tariffsPhotos = photos
    .filter(({ type }) => type === InspectionPhotoTypeEnum.TARIFFS)
    .map(mapPhotoToImage)
    .filter((photo): photo is GalleryImage => !!photo)

  const mileagePhotos = photos
    .filter(({ type }) => type === InspectionPhotoTypeEnum.MILEAGE)
    .map(mapPhotoToImage)
    .filter((photo): photo is GalleryImage => !!photo)

  const lastToPhotos = photos
    .filter(({ type }) => type === InspectionPhotoTypeEnum.LAST_TO)
    .map(mapPhotoToImage)
    .filter((photo): photo is GalleryImage => !!photo)

  const emptyPhoto = <Typography>{t('no photo')}</Typography>

  return (
    <Container sx={{ minHeight: '220px' }}>
      {loading && (
        <>
          <ContainerTitle>{t('form.photos')}</ContainerTitle>
          <Box sx={{ position: 'relative', flex: 1 }}>
            <Skeleton sx={{ borderRadius: '8px' }} />
          </Box>
        </>
      )}
      {!loading && (
        <>
          <ContainerTitle>{t('form.car photos')}</ContainerTitle>
          {carPhotos?.length ? <Gallery images={carPhotos} /> : emptyPhoto}
          <br />

          <ContainerTitle>{t('form.tariff grid')}</ContainerTitle>
          {tariffsPhotos?.length ? (
            <Gallery images={tariffsPhotos} />
          ) : (
            emptyPhoto
          )}
          <br />

          <ContainerTitle>{t('form.mileage photos')}</ContainerTitle>
          {mileagePhotos?.length ? (
            <Gallery images={mileagePhotos} />
          ) : (
            emptyPhoto
          )}
          <br />

          <ContainerTitle>{t('form.maintenance tag')}</ContainerTitle>
          {lastToPhotos?.length ? (
            <Gallery images={lastToPhotos} />
          ) : (
            emptyPhoto
          )}
        </>
      )}
    </Container>
  )
}
